import { useEffect, useState } from 'react'

import { StorageGetItem, USER } from '../lib/storage'

export const useStoredUser = (enabled = true) => {
  const [stored, setStored] = useState({ read: false, user: null })

  useEffect(() => {
    if (!enabled) return undefined
    let current = true
    StorageGetItem(USER).then((result) => {
      if (current) setStored({ read: true, user: result || null })
    })
    return () => {
      current = false
    }
  }, [enabled])

  return { viewer: stored.user, viewerReady: !enabled || stored.read }
}
